import React, { useState, useEffect } from "react";
import useAuth from "../auth/hooks/useAuth";
import styled, { keyframes } from "styled-components";
import { Link } from "@reach/router";
import { LinkButton } from "../../globals/components/button";
import axios from "axios";
//images
import background from "./assets/background.png";
import popupScreen from "./assets/popup.png";
import aimee from "./assets/aimee.png";
import emile from "./assets/emile_trophy.png";
import scrambler from "./assets/Scrambler.png";
import rankTitle from "./assets/rank.png";
import rankBox from "./assets/rank_box.png";
import answeredBox from "./assets/answered.png";
//the rest
import { Scale } from 'react-scaling';
import UseServices from '../games/hooks/useServices';
//import UseAllRanks from '../games/hooks/useAllRanks';
import game_data from '../games/game_data';
import MenuItem from "./styled_components/menu-item";

const RankContainer = styled.div`
  display: flex;
  justify-content: center;
  position: fixed;
  align-items: center;
  height: 100%;
  width: 100%;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  padding: 2.5em;

  h1 {
    color: white;
    margin: 0;
    margin-bottom: 0.25em;
    font-size: 5em;
  }
`;

const PopupContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(${popupScreen});
  background-size: contain;
  background-repeat: no-repeat;
  width: 994px;
  height: 530px;
  padding: 40px;
`;

const Title = styled.h1`
  color: #673c8c;
  margin: 0;
  font-size: 2.5em;
  text-align: center;
`;

const AnsweredBox = styled.div`
  position: relative;
  width: 388px;
  height: 104px;
  margin-top: 20px;
`;

const AnsweredImage = styled.img`
  width: 388px;
  height: 104px;
`;

const AnsweredText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 5em;
  font-weight: bold;
  text-align: center;
`;

const RankRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 40px;
`;

const RankTitle = styled.div`
  position: relative;
  width: 244px;
  height: 99px;
`;

const RankTitleImage = styled.img`
  width: 244px;
  height: 99px;
`;

const RankTitleText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 6em;
  font-weight: bold;
  text-align: center;
`;

const RankBox = styled.div`
  position: relative;
  width: 537px;
  height: 99px;
  margin-left: 20px;
`;

const RankBoxImage = styled.img`
  width: 537px;
  height: 99px;
`;

const RankText = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 8em;
  font-weight: bold;
  text-align: center;
`;

const float = keyframes`
  0% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
  100% { transform: translateY(0); }
`;

const EmileImage = styled.img`
  position: absolute;
  bottom: 20%;
  left: 20px;
  height: 429px;
  animation: ${float} 4s ease-in-out infinite;
`;

const RightImages = styled.div`
  position: absolute;
  bottom: 0%;
  right: -5%;
  display: flex;
  align-items: flex-end;
`;

const CharacterImage = styled.img`
  &.aimee {
    height: 375px;
    z-index: 2;
    margin-right: -150px;
  }
  &.scrambler {
    height: 491px;
    z-index: 1;
  }
`;

export default function Ranks() {
  const { state } = useAuth();
  const [pupilRank, setPupilRank] = useState({ correct: 0, rank: 0 }); // Default values
  const { access_token } = state;

  useEffect(() => {
    async function fetchPupilRank() {
      try {
        const response = await axios({
          method: "get",
          url: `${process.env.REACT_APP_API}/getpupilrank`,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`
          },
        });
        const data = response.data;
        console.log("Pupil Rank:", data);
        setPupilRank({
          correct: data.correct,
          rank: data.rank,
        });
      } catch (e) {
        console.log("Error fetching pupil rank:", e);
      }
    }

    fetchPupilRank();
  }, []); // Empty dependency array to run once on mount

  return (
    <Scale scaleTo={1920}>
      <RankContainer>
        <PopupContainer>
          <Title>Questions answered in the last 90 days</Title>
          <AnsweredBox>
            <AnsweredImage src={answeredBox} />
            <AnsweredText>{pupilRank.correct.toLocaleString()}</AnsweredText>
          </AnsweredBox>
          <RankRow>
            <RankTitle>
              <RankTitleImage src={rankTitle} />
              <RankTitleText>Rank</RankTitleText>
            </RankTitle>
            <RankBox>
              <RankBoxImage src={rankBox} />
              <RankText>{pupilRank.rank.toLocaleString()}</RankText>
            </RankBox>
          </RankRow>
        </PopupContainer>
        <EmileImage src={emile} />
        <RightImages>
          <CharacterImage className="aimee" src={aimee} />
          <CharacterImage className="scrambler" src={scrambler} />
        </RightImages>
      </RankContainer>
    </Scale>
  );
}